import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Params, Route } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { map } from 'rxjs';
import { SmagUser } from '../_models';
import { localStorageService } from '../_services/local-storage.service';
import { LoadingService } from '../framework/auth/components/loading/loading.service';

@Injectable()
export class AuthGuard  {
    constructor(private router: Router, private auth: AuthenticationService,private  _loadingService: LoadingService) {

    }

    /// There are three situationas to check:
    /// 1. If the user is not login, he point directly to home, then return false;
    /// 2. If the user is logined using jwt (Jarvis Icon), then try to valid the token;
    /// 3. if the user is already login, the currentUser != null, in this situation, we need to check if the token is expired or not;
    /// Session invalide : on la supprime puis on re-navigue sur la même URL.
    /// La route 'home' (canMatch) affiche alors le formulaire de connexion sans changer l'URL.
    private showLoginInPlace(url: string) {
        this._loadingService.hide();
        localStorageService.SetCurrentUser(null);
        this.router.navigateByUrl(url, { onSameUrlNavigation: 'reload' });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const token = route.queryParams['token'];

        // situation 1
        if (!token && localStorageService.GetJsonCurrentUserBrut(true) == null) {
            // not logged in : le formulaire de connexion est affiché sur place par la route 'home' (canMatch)
               this._loadingService.hide();
            return false;
        }
        // situation 2
        if (token) {

            localStorageService.set('currentToken', token);
            //efface curentUser
            localStorageService.SetCurrentUser(null);

            return this.auth.verifyLegacyToken(token).pipe(
              map((response:boolean|any) => {
                if (localStorageService.GetJsonCurrentUserBrut(true) !== null) {
                    const urlWithoutAccessToken = state.url.replace(new RegExp('.token=' + token), '');
                    this.router.navigateByUrl(urlWithoutAccessToken);
                    return true;
                } else {
                       this._loadingService.hide();
                      // token invalide : on réaffiche l'URL (sans token), le formulaire de connexion est affiché sur place
                      this.showLoginInPlace(state.url.replace(new RegExp('.token=' + token), ''));
                      return false;
                  }
              })
            );

        }

        // situation 3
        if (localStorageService.GetJsonCurrentUserBrut(true) !== null) {

            if (this.auth.AreTokensExpired() == true) {
                   this._loadingService.hide();
                   this._loadingService.show("Patientez durant le rechargement de l'application ...");
                this.auth.refreshSmagUserTokens().subscribe({
                   next:(updated: boolean) => {
                        if (updated == true) {
                            this._loadingService.hide();
                            this.router.navigateByUrl(state.url) ;
                            return true;
                        } else {
                            this.showLoginInPlace(state.url);
                            return false;
                        }
                    },
                    error: (err:any) => {
                        this.showLoginInPlace(state.url);
                            return false;
                    }
                }
                );
            } else {
              return true;
            }
        }
    }
}

@Injectable()
export class AuthCanLoadGuard  {

    canLoad(route: Route): boolean {
        if (localStorageService.GetJsonCurrentUserBrut(true) !== null) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page
        this.router.navigate(['/auth/login']);
        return false;
    }
    constructor(private router: Router, private auth: AuthenticationService) {

    }

}
